require("dotenv").config({
  path: `.env.${process.env.NODE_ENV}`,
})

const languages = require('./src/data/languages')

const serverName = 'https://heed-retreat-prod-backend.parallelpublicworks.com'
module.exports = {
  flags: {
    DEV_SSR: false
  },
  siteMetadata: {
    title: 'HEED Retreat',
    description: 'Application and LOR requests',
    keywords: 'gatsby,theme,carbon',
    drupalUrl: serverName,
    langs: languages
  },
  pathPrefix: `/gtc`,
  plugins: [
    {
      resolve: 'gatsby-plugin-manifest',
      options: {
        name: 'HEED Retreat',
        short_name: 'HEED Retreat',
        start_url: '/',
        background_color: '#ffffff',
        theme_color: '#71AD50',
        display: 'browser',
        icon: './src/images/favicon.svg',
      },
    },
    {
      resolve: 'gatsby-source-drupal',
      options: {
        baseUrl: serverName,
        langs: languages,
        skipFileDownloads: true,
        basicAuth: {
          username: process.env.BASIC_AUTH_USERNAME,
          password: process.env.BASIC_AUTH_PASSWORD,
        }
      }
    },
    {
      resolve: 'gatsby-theme-carbon',
      options: {
        isSearchEnabled: false,
        iconPath: './src/images/favicon.svg',
        repository: {
          baseUrl:
            'https://github.com/carbon-design-system/gatsby-theme-carbon',
          subDirectory: '/packages/example',
        },
      },
    },
    {
      resolve: `gatsby-source-drupal-menu-links`,
      options: {
        baseUrl: serverName,
        apiBase: `jsonapi`,
        menus: ["main"],
        basicAuth: {
          username: process.env.BASIC_AUTH_USERNAME,
          password: process.env.BASIC_AUTH_PASSWORD,
        }
      },
    },
  ]
};
